/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    parts: [
        'container',
        'list',
        'headingLink',
        'heading',
        'headingAll',
        'listItem',
        'listItemSx',
        'badge',
        'wrapperStyles',
        'defaultListStyle',
        'bgColorPadding'
    ],
    baseStyle: {
        container: {
            color: 'white'
        },
        list: {
            fontSize: 'webMd',
            spacing: 3
        },
        headingLink: {
            display: 'inline-flex'
        },
        heading: {
            fontSize: 'webLg',
            paddingTop: 3,
            paddingBottom: 3
        },
        headingAll: {
            fontSize: 'webMd',
            fontWeight: '500',
            lineHeight: '20px'
        },
        bgColorPadding: {
            padding: '1px'
        }
    },
    variants: {
        vertical: {
            list: {
                spacing: 3.5
            }
        },
        horizontal: {
            list: {
                display: 'flex',
                flexDirection: 'row',
                gap: '0.5rem'
            },
            listItem: {
                borderLeft: '1px solid',
                paddingLeft: 2
            },
            listItemSx: {
                '&:first-of-type': {
                    borderLeft: 0,
                    paddingLeft: 0
                }
            }
        },
        menuItem: {
            container: {
                color: 'black'
            },
            wrapperStyles: {
                display: {base: 'flex'}
            },
            defaultListStyle: {
                display: {base: 'flex'}
            },
            heading: {
                padding: 0,
                textStyle: 'bodySmMedium'
            },
            list: {
                textStyle: 'labelXs',
                spacing: '10px'
            },
            badge: {
                textStyle: 'badge',
                marginLeft: {base: 1},
                padding: {base: 1},
                backgroundColor: 'backgroundPrimaryBrand'
            }
        }
    },
    defaultProps: {
        variant: 'vertical'
    }
}
